import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { dripKeys } from './queryKeys';
import useQueryRequestParams from '../../../hooks/useQueryRequestParams';
import markUrl from './markUrl';
const useDripVersions = (dripId, params) => {
    const additional = useQueryRequestParams();
    return useQuery({
        queryKey: dripKeys.versions(dripId, params),
        queryFn: () => axios.get(markUrl('drips/versions/'), {
            ...additional,
            params: { drip_id: dripId, ...params }
        }),
        staleTime: 30_000,
        enabled: dripId > 0
    });
};
export default useDripVersions;
